import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32c95809")

_pushScopeId("data-v-32c95809")
const _hoisted_1 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AppLayout = _resolveComponent("AppLayout")
  const _component_GlobalProgressSpinner = _resolveComponent("GlobalProgressSpinner")
  const _component_Scroll = _resolveComponent("Scroll")

  return (_openBlock(), _createBlock("div", {
    class: ["app -stop-dragging", !!_ctx.getGlobalLoading ? 'dialog--open' : '']
  }, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLayout, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_1)),
    (_ctx.getGlobalLoading)
      ? (_openBlock(), _createBlock(_component_GlobalProgressSpinner, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Scroll)
  ], 2))
})